const Vibi = {
    //network info
    averageBlockTime: 15,
    chainId: '0x0132',
    name: 'Vibi',
    shortName: 'vibi',
    token: 'VBC',
    type: 'Ethereum 1.0',
    timeInterval: 5_000,

    //endpoint
    endpoint: process.env.VIBI_ENDPOINT,
    chainApiEndpoint: process.env.VIBI_API_ENDPOINT,
    // infoApiEndpoint: process.env.VIBI_INFO_ENDPOINT,

    //style
    chartStyle: ['#043990', '#a5c7ff'],
    color: {
        from: '#043990',
        to: '#a5c7ff',
        fromPosition: '25.72%',
        toPosition: '113.63%'
    },

    //image
    backgroundImage:
        'https://res.cloudinary.com/vbchain/image/upload/v1693997973/block_explorer/GeneralInfo/Vibi/vibiHome_tpdhpx.svg',

    networkIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1694572808/block_explorer/GeneralInfo/Vibi/Vibi-light_bgb2fd.svg',
    averageBlockTimeIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1693997979/block_explorer/GeneralInfo/Vibi/totalBlockTime_twiunk.svg',
    totalTransactionsIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1693997975/block_explorer/GeneralInfo/Vibi/totalTransaction_k1a3oe.svg',
    totalActiveAddressesIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1693997974/block_explorer/GeneralInfo/Vibi/totalAccount_mq0rbw.svg',
    latestBlockIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1693997975/block_explorer/GeneralInfo/Vibi/totalBlock_zwpmvy.svg'
}

module.exports = Vibi
